import React from 'react';

class Developers extends React.Component {
  render() {
    return (
      <div class="text-center my-4">
        <h4>Developers</h4>
        <div class="row">
          <div class="col-md-4">
            <p>Rob Hageboeck<br/>Indiana University</p>
          </div>
          <div class="col-md-4">
            <p>Daniel Liu<br/>Park Tudor School</p>
          </div>
          <div class="col-md-4">
            <p>Nianjun Liu<br/>Indiana University<br/><a href="https://publichealth.indiana.edu/research/faculty-directory/profile.html?user=liunian">Dr. Liu's Profile</a></p>
          </div>
        </div>
      </div>
    );
  }  
}

export default Developers;
